module.exports = __webpack_public_path__ + "static/awareness-1877f90e73050b22bf5b4a1bc8d67768.png";